<kendo-label class="k-display-block" [text]="$displayName()">
  <kendo-textbox [value]="$value()" [disabled]="true" [title]="$value()" />
</kendo-label>
